(function() {
  angular.module('general')
    .controller('faqController', ['$scope', '$translate', 'asyncYamlLoader', '$location', '$rootScope',
      function ($scope, $translate, asyncYamlLoader, $location, $rootScope) {
        var vm = this;
        vm.applicationName = $rootScope.applicationName;
        asyncYamlLoader().then(function(data) {
          if (!vm.faqList) {
            vm.faqList = [];
          }
          Array.prototype.push.apply(vm.faqList, data.content.faq);
        });
        $scope.scrollTo = function (id) {
          $location.hash('q' + id);
        };
      }]);
})();
